// firebase
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyC8U5w3jH3zCqaUSMLGk5REi0aD7JtQnBo",
    authDomain: "mentari-b21d4.firebaseapp.com",
    projectId: "mentari-b21d4",
    storageBucket: "mentari-b21d4.firebasestorage.app",
    messagingSenderId: "350414843851",
    appId: "1:350414843851:web:2f7722ef41235bc847d04e",
    measurementId: "G-NDV2FG1CBG",
};

// Initialize Firebase
const fireApp = initializeApp(firebaseConfig);
const analytics = () => {
    getAnalytics(fireApp);
};
// const messaging = getMessaging(fireApp);

export { analytics };
